import logo from '@images/logo.png';
import dark_logo from '@images/logo_dark.png';
import Layout from 'antd/es/layout';
import Typography from 'antd/es/typography';
import React from 'react';
import styled from 'styled-components';

import { useTheme } from '@components/ThemeProvider';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const StyledHeader = styled(AntHeader)`
  display: flex;
  padding: ${({ theme }) => theme.token.padding}px;
  gap: 0.75rem;
  background: transparent;
`;

const StyledTitle = styled(Title)`
  color: ${({ theme }) => theme.token.colorPrimary} !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

const Header: React.FC = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <StyledHeader>
      <TitleContainer>
        {/* <img src={logo} alt="Catalyzed Logo" style={{ width: '1.5rem' }} /> */}
        <img
          src={isDark ? dark_logo : logo}
          alt="Catalyzed Logo"
          style={{ width: '1.5rem' }}
        />
        <StyledTitle level={3}>Catalyzed</StyledTitle>
      </TitleContainer>
    </StyledHeader>
  );
};

export default Header;
